import React from 'react'
import PropTypes from 'prop-types'
import KMI from './KMI'
import Modal from '../../2_Molecules/Modal/Modal'

const KMIModal = ({
  formExtraParams
}) => {
  const { formImage, ...restParams } = formExtraParams
  return (
    <Modal
      className="mz-kmi-modal mz-popup-modal"
      style={{ backgroundImage: formImage ? `url(${formImage})` : '' }}
      isDark={true}
    >
      <KMI
        formExtraParams={restParams}
      />
    </Modal>
  )
}

KMIModal.propTypes = {
  formExtraParams: PropTypes.object.isRequired
}

export default KMIModal

